module.exports = __webpack_public_path__ + "static/media/website-white-bg-trimmed.fc90816a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/website-white-bg-trimmed.svg
 ** module id = 940
 ** module chunks = 44
 **/